import React, { useState, useEffect, use } from 'react'
import { getEmailTemplatesList, deleteEmailTemplateById, getEmailTemplateSearchBySubjectKeyword, SaveEmailTemplateByData, UpdateEmailTemplateByData, TestEmailTemplate, GetEmailTempalteFilesList, deleteEmailTempalteFilesList, uploadEmailTempalteFilesList, GetEmailTemplateHTML } from "../ActionCreator";
import Multiselect from "multiselect-react-dropdown";
import ReactQuill from "react-quill";
import ConfirmationPopup from "../../../../presentationals/Popup/ConfirmationPopup.component";
import NodataImage from '../../../../../images/nodata.png'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import AddIcon from '@mui/icons-material/Add';
import DescriptionIcon from '@mui/icons-material/Description';
import Popup from '../../../../presentationals/Popup/Popup.component'
import Loader from '../../../../presentationals/Loader/Loader.component'
import { COMPANY_NAME } from '../../../../../utils/api-factory';
import { formatDateNew } from '../../../../../utils/commonUtility';
import Pagination from '@mui/material/Pagination';

const itemsPerPage = 10;
const quillModules = {
    toolbar: [
        [{ font: [] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        ["blockquote"],
        [
            { list: "ordered" },
            { list: "bullet" },
            { indent: "-1" },
            { indent: "+1" },
        ],
        [{ align: [] }],
        ["link", "image"],
    ],
};

const quillFormats = [
    "header",
    "font",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "color",
    "background",
    "align",
];

const Email = ({ admin }) => {
    const [loader, setLoader] = useState(false)
    const [searchValue, setSearchValue] = useState("")
    const [viewType, setViewType] = useState("list")
    const [showModal, setshowModal] = useState(false)
    const [editData, setEditData] = useState({})
    const [list, setList] = useState([])
    const [listTableData, setlistTableData] = useState([])
    const [currentPage, setcurrentPage] = useState(1)
    const [popup, setPopup] = useState({ show: false, popupStatus: "" })
    const [deleteData, setDeleteData] = useState({})
    const [TestTemplate, setTestTemplate] = useState({ show: false, data: {} })
    const [TemplateObj, setTemplateObj] = useState({})
    const [uploadListData, setUploadListData] = useState([])
    const [addTab, setAddTab] = useState("email")
    const [filesData, setFilesData] = useState({ fileToUpload: "", nameOfFile: "" })
    const [previewTemplate, setPreviewTemplate] = useState({ show: false, data: "", nameOfFile: "" })
    const [objectData, setObjectData] = useState({
        emailSubject: "",
        emailPath: "",
        async: false,
        fileId: "",
        placeholders: ""
    })

    useEffect(() => {
        getEmailTemplatesListFn()
        GetEmailTempalteFilesListfn()
    }, []);

    const handlePage = (type, data) => {
        setViewType(type)
        if (type == "add") {
            setEditData(data)
            setObjectData({
                emailSubject: data?.emailSubject || "",
                emailPath: data?.emailPath || "",
                async: data?.async || "",
                fileId: data?.fileId || "",
                placeholders: data?.placeholders || "",
            })
        } else if (type == "list") {
            getEmailTemplatesListFn()
            setEditData({})
            setObjectData({
                emailSubject: "",
                emailPath: "",
                async: false,
                fileId: "",
                placeholders: "",
            })
        }
    }

    const cancelLoanConfirm = (type) => {
        if (type == "yes") {
            deleteEmailTemplateByIdFn(deleteData?.emailId)
            setshowModal(false)
        } else if (type == "no") {
            setshowModal(false)
            setDeleteData({})
        }
    }

    const handleDelete = (data) => {
        setDeleteData(data)
        setshowModal(true)
    }

    const closePopup = () => {
        setPopup({ show: false, popupStatus: "" })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }

    const handleSearchbtn = (e) => {
        if (e.key == "Enter" && searchValue?.length > 0) {
            getEmailTemplateSearchBySubjectKeywordFn()
        }
    }

    const changeSearchValue = (e) => {
        setSearchValue(e.target.value)
        if (e.target.value == "") {
            getEmailTemplatesListFn()
        }
    }

    const handleAddchange = (e, type) => {
        if (type == "emailPath") {
            const d = uploadListData?.filter((el) => el.fileId == e.target.value)
            setObjectData((prev) => ({
                ...prev,
                "emailPath": d?.[0]?.fileName,
                "fileId": e.target.value,
                "placeholders": d?.[0]?.placeholders,
            }))
        } else {
            setObjectData((prev) => ({
                ...prev,
                [type]: e.target.value
            }))
        }
    }

    const handleSave = (e) => {
        console.log("objectData", objectData)
        if (objectData?.fileId === "" || objectData?.fileId === null || objectData?.fileId === undefined) {
            setPopup({ show: true, popupStatus: "Please Select a Template" })
            removePopup()
        } else if (objectData?.emailSubject === "" || objectData?.emailSubject === null || objectData?.emailSubject === undefined) {
            setPopup({ show: true, popupStatus: "Subject Field is Required" })
            removePopup()
        } else if (editData?.emailId) {
            // update Fn
            const obj = {
                "emailId": editData?.emailId,
                "emailSubject": objectData?.emailSubject,
                "fileId": objectData?.fileId,
                "emailPath": objectData?.emailPath,
                "async": objectData?.async || false,
                "attachment": false,
                "companyName": COMPANY_NAME,
                "placeholders": objectData?.placeholders
            }
            UpdateEmailTemplateByDataFn(editData?.emailId, obj)

        } else {
            const obj = {
                "emailSubject": objectData?.emailSubject,
                "fileId": objectData?.fileId,
                "emailPath": objectData?.emailPath,
                "async": objectData?.async || false,
                "attachment": false,
                "companyName": COMPANY_NAME,
                "placeholders": objectData?.placeholders
            }
            SaveEmailTemplateByDataFn(obj)
        }
    }

    const handlePagePagination = (event, value) => {
        setcurrentPage(value);
        const data = filterFunction(listTableData, value)
        setList(data)
    };

    const filterFunction = (data, currentPageNo) => {
        const indexOfLastItem = currentPageNo * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        const currentItems = data && data?.length > 0 ? data?.slice(indexOfFirstItem, indexOfLastItem) : [];
        return currentItems
    }


    const getEmailTemplatesListFn = () => {
        setLoader(true)
        getEmailTemplatesList("",callback => {
            setLoader(false)
            if (callback && callback?.message == "success" && callback?.data?.length > 0) {
                const responseData = callback?.data || [];
                setlistTableData(responseData)
                const data = filterFunction(responseData, 1)
                setList(data)
            } else {
                setList([])
                setlistTableData([])
            }
        })
    }

    const deleteEmailTemplateByIdFn = (id) => {
        setLoader(true)
        deleteEmailTemplateById(id, callback => {
            setLoader(false)
            if (callback && callback?.message == "success") {
                setPopup({ show: true, popupStatus: "Template Deleted Successfully" })
                getEmailTemplatesListFn()
                setDeleteData({})
            } else {
                setPopup({ show: true, popupStatus: "Error Deleting Template" })
                setDeleteData({})
            }
            removePopup()
        })
    }

    const getEmailTemplateSearchBySubjectKeywordFn = () => {
        setLoader(true)
        getEmailTemplateSearchBySubjectKeyword(searchValue, callback => {
            setLoader(false)
            if (callback && callback?.message == "success" && callback?.data?.length > 0) {
                const responseData = callback?.data || [];
                setlistTableData(responseData)
                const data = filterFunction(responseData, 1)
                setList(data)
            } else {
                setList([])
                setlistTableData([])
            }
        })
    }

    const SaveEmailTemplateByDataFn = (data) => {
        setLoader(true)
        SaveEmailTemplateByData(data, callback => {
            setLoader(false)
            if (callback && callback?.message == "success") {
                setPopup({ show: true, popupStatus: "Data Saved Successfully" })
                setObjectData({
                    "emailSubject": "",
                    "fileId": "",
                    "emailPath": "",
                    "async": false,
                    "placeholders": ""
                })
            } else if (callback?.data !== null) {
                setPopup({ show: true, popupStatus: callback?.data })
            } else {
                setPopup({ show: true, popupStatus: "Error Saving Data" })
            }
            removePopup()
        })
    }
    const UpdateEmailTemplateByDataFn = (id, data) => {
        setLoader(true)
        UpdateEmailTemplateByData(id, data, callback => {
            setLoader(false)
            if (callback && callback?.message == "success") {
                setPopup({ show: true, popupStatus: "Data Updated Successfully" })
                setObjectData({
                    "emailSubject": "",
                    "fileId": "",
                    "emailPath": "",
                    "async": false,
                    "placeholders": ""
                })
            } else if (callback?.data !== null) {
                setPopup({ show: true, popupStatus: callback?.data })
            } else {
                setPopup({ show: true, popupStatus: "Error Updating Data" })
            }
            removePopup()
        })
    }

    const GetEmailTempalteFilesListfn = (id, data) => {
        setLoader(true)
        GetEmailTempalteFilesList(callback => {
            setLoader(false)
            if (callback && callback?.message == "success") {
                setUploadListData(callback?.data)
            } else {
                setUploadListData([])
            }
            removePopup()
        })
    }
    const GetEmailTemplateHTMLFn = (data) => {
        setLoader(true)
        GetEmailTemplateHTML(data?.fileId, callback => {
            setLoader(false)
            console.log(callback, "ca")
            if (callback && callback == "file not found") {
                setPreviewTemplate({ show: false, data: "", nameOfFile: "" })
                setPopup({ show: true, popupStatus: "File Not Found" })
            } else {
                setPreviewTemplate({ show: true, data: callback, nameOfFile: data?.emailPath })
            }
            removePopup()
        })
    }

    const ViewListPreviewEmail = (data) => {
        GetEmailTemplateHTMLFn(data)
    }

    const handleUploadDelete = (data) => {
        setLoader(true)
        deleteEmailTempalteFilesList(data?.fileId, "", callback => {
            setLoader(false)
            setPopup({ show: true, popupStatus: callback?.data })
            removePopup()
        })
    }


    const closeTestingPopup = (type, data) => {
        if (type == true) {
            if (data?.placeholders?.length > 0) {

                const matches = data?.placeholders?.length > 0;
                if (!matches) {
                    setTemplateObj({ emailId: "" })
                } else {
                    const placeholdersArray = data?.placeholders?.split(',') || [];
                    const obj = Object.fromEntries(placeholdersArray.map(key => [key.trim(), ""]));
                    // const obj = Object.fromEntries(data?.placeholders.map(key => [key, ""]));
                    obj.emailId = ""
                    setTemplateObj(obj);
                }
                setTestTemplate({ show: true, data: data })

            } else {
                setTestTemplate({ show: true, data: data })
                setTemplateObj({ emailId: "" })
            }

        } else if (type == false) {
            setTestTemplate({ show: false, data: "" })
            setTemplateObj({})
        }
    }


    const handleTemplateObjChnage = (e, type) => {
        setTemplateObj((prev) => ({
            ...prev,
            [type]: e.target.value
        }))
    }

    const HandleSendTest = () => {


        if (TemplateObj && Object.keys(TemplateObj)?.length > 0) {
            for (let value of Object.keys(TemplateObj)) {
                if (TemplateObj[value] == null || TemplateObj[value] == undefined || TemplateObj[value] == "") {
                    setPopup({ show: true, popupStatus: `${value} is Required` })
                    removePopup()
                    return
                }
            }
            console.log("mess send")
            const { emailId, ...restObj } = TemplateObj
            const obj = { ...restObj }
            if (TemplateObj?.emiDate) {
                const newDate = moment(TemplateObj?.emiDate).format("DD-MM-YYYY")
                obj.emiDate = newDate
            }
            setLoader(true)
            TestEmailTemplate(emailId, TestTemplate?.data?.emailId, obj, callback => {
                setLoader(false)
                console.log(callback)
                if (callback == "success") {
                    setPopup({ show: true, popupStatus: "Mail Send successfully" })
                    closeTestingPopup(false, "")
                } else {
                    setPopup({ show: true, popupStatus: "Error Sending Mail" })
                }
                removePopup()
            })
        }
    }

    const HandleAddTab = (type) => {
        setAddTab(type)
        setFilesData({ fileToUpload: '', nameOfFile: '' })
        setObjectData({
            emailSubject: "",
            emailPath: "",
            async: false,
        })
    }

    function fileHandler(e) {
        console.log("e", e.target.files)
        if (e.target.files[0] !== undefined && e.target.files[0] !== '') {
            if (e.target.files[0].name?.includes(".html") || e.target.files[0].name?.includes(".jsp")) {
                setFilesData({ fileToUpload: e.target.files[0], nameOfFile: e.target.files[0].name })
            } else {
                setFilesData({ fileToUpload: '', nameOfFile: '' })
                setPopup({ show: true, popupStatus: "only HTML or JSP file is allowed" })
                removePopup()

            }
        }
    }

    const UploadFile = () => {
        setLoader(true)
        uploadEmailTempalteFilesList(filesData?.fileToUpload, callback => {
            setLoader(false)
            if (callback && callback?.message == "success") {
                setPopup({ show: true, popupStatus: "File Uploaded successfully" })
            } else {
                setPopup({ show: true, popupStatus: "Error Uploading File" })
            }
            removePopup()
            setFilesData({ fileToUpload: '', nameOfFile: '' })
        })
    }


    const handlePreview = () => {
        if (filesData?.fileToUpload == null || filesData?.fileToUpload == undefined || filesData?.fileToUpload == "") return;

        const reader = new FileReader();
        reader.onload = (e) => {
            setPreviewTemplate({ show: true, data: e.target.result, nameOfFile: filesData?.nameOfFile })
        };
        reader.readAsText(filesData?.fileToUpload);
    }




    return (
        <>
            <div className="container-fluid marketing-main-css" style={{ margin: '100px 0 40px 0' }}>
                {
                    loader ?
                        <Loader /> : ''
                }
                {showModal ?
                    <ConfirmationPopup cancelLoanConfirm={cancelLoanConfirm} confirmationText={'Are you sure you want to delete this template?'} />
                    : ""}

                {popup?.show ?
                    <Popup closePopup={closePopup} popupStatus={popup?.popupStatus} />
                    : ''}


                <div className="row">
                    <div style={{ display: 'flex', marginBottom: '20px' }}>

                        <button onClick={() => handlePage('list', "")} className="btn" style={{ color: viewType === "list" ? "#fff" : "#000", background: viewType === "list" ? "#337ab7" : '#f4f3f1', padding: '10px', borderRadius: '5px', display: 'flex', margin: '0 16px' }}>
                            <FormatListBulletedIcon style={{ margin: '0', fontSize: '18px', fontWeight: '800' }} />
                        </button>

                        {/* <button onClick={() => handlePage('uploadList', "")} className="btn " style={{ color: viewType === "uploadList" ? "#fff" : "#000", background: viewType === "uploadList" ? "#337ab7" : '#f4f3f1', padding: '10px', borderRadius: '5px', display: 'flex', marginRight: '16px' }}>
                            <DescriptionIcon style={{ margin: '0', fontSize: '18px', fontWeight: '800' }} />
                        </button> */}
                        <button onClick={() => handlePage('add', "")} className="btn " style={{ color: viewType === "add" ? "#fff" : "#000", background: viewType === "add" ? "#337ab7" : '#f4f3f1', padding: '10px', borderRadius: '5px', display: 'flex' }}>
                            <AddIcon style={{ margin: '0', fontSize: '18px', fontWeight: '800' }} />
                        </button>

                    </div>

                    {viewType === 'list' ?
                        <div className="col-sm-12 col-xs-12">
                            <div className="row" style={{ marginTop: '15px' }}>
                                <div className="col-lg-2 col-sm-3 col-xs-4">
                                    <label htmlFor=""><i class="fa fa-search" aria-hidden="true"></i>&nbsp;Search</label>
                                    <input className='form-control' placeholder='Search by Subject' type='search' value={searchValue} onChange={(e) => changeSearchValue(e)} onKeyDown={(e) => handleSearchbtn(e)} />
                                </div>
                            </div>
                            <hr />
                            {list !== '' && list?.length > 0 ?
                                <>
                                    <div className="phocket-table-new" style={{ boxShadow: '3px 3px 10px 3px #eee', borderRadius: '15px' }}>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th className='text-center'>Subject</th>
                                                    <th className='text-center'>Body</th>
                                                    <th className='text-center'>Async</th>
                                                    <th className='text-center'>Added On</th>
                                                    <th className='text-center'>Test</th>
                                                    <th className='text-center'>Edit</th>
                                                    <th className='text-center'>view</th>
                                                    <th className='text-center'>Delete</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {list && list?.length > 0 ? list?.map((data, i) => (
                                                    <tr key={i}>
                                                        <td className='text-center'>{data.emailSubject}</td>
                                                        <td className='text-center'>{data?.emailPath}</td>
                                                        <td className='text-center'>{data.async ? "Yes" : "No"}</td>
                                                        <td className='text-center'>{formatDateNew(data?.creationDate)}</td>
                                                        <td className='text-center'><button className='btn' style={{ background: "#337ab7", color: '#fff' }} onClick={() => closeTestingPopup(true, data)}>Test</button></td>
                                                        <td className='text-center'><i style={{ cursor: 'pointer' }} className="fa fa-edit" onClick={() => handlePage('add', data)}></i></td>
                                                        <td className='text-center'><i style={{ cursor: 'pointer' }} className="fa fa-eye" onClick={() => ViewListPreviewEmail(data)}></i></td>
                                                        <td className='text-center'><i style={{ cursor: 'pointer' }} className="fa fa-trash" onClick={() => handleDelete(data)}></i></td>
                                                    </tr>
                                                )) : ""}
                                            </tbody>
                                        </table>
                                        <div style={{ float: "right", marginTop: '20px' }}>
                                            <Pagination
                                                count={Math.ceil(listTableData?.length / itemsPerPage)}
                                                page={currentPage}
                                                onChange={handlePagePagination}
                                                color="primary"
                                            />
                                        </div>
                                    </div>
                                </>
                                :
                                <div style={{ width: '100%' }} className="text-center"><img style={{ width: '30%', marginTop: '50px', marginLeft: 'auto', marginRight: 'auto' }} src={NodataImage} /></div>}


                        </div>
                        : ""}
                    {viewType === 'uploadList' ?
                        <div className="col-sm-12 col-xs-12">

                            {uploadListData !== '' && uploadListData?.length > 0 ?
                                <>
                                    <div className="phocket-table-new" style={{ boxShadow: '3px 3px 10px 3px #eee', borderRadius: '15px' }}>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th className='text-center'>File Name</th>
                                                    <th className='text-center'>Placeholders</th>
                                                    <th className='text-center'>Delete</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {uploadListData && uploadListData?.length > 0 ? uploadListData?.map((data, i) => (
                                                    <tr key={i}>
                                                        <td className='text-center'>{data?.fileName}</td>
                                                        <td className='text-center'>{data?.placeholders}</td>
                                                        <td className='text-center'><i style={{ cursor: 'pointer' }} className="fa fa-trash" onClick={() => handleUploadDelete(data)}></i></td>
                                                    </tr>
                                                )) : ""}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                                :
                                <div style={{ width: '100%' }} className="text-center"><img style={{ width: '30%', marginTop: '50px', marginLeft: 'auto', marginRight: 'auto' }} src={NodataImage} /></div>}


                        </div>
                        : ""}


                    {viewType === 'add' ?
                        <div className="col-xs-12" style={{ marginTop: '20px' }}>
                            <div className="shadow" style={{ boxShadow: '0 4px 8px 0 rgba(0,0,0,.2)', padding: '15px', borderRadius: '6px' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <h4 style={{ marginTop: '10px', fontSize: '16px', marginRight: '15px', color: addTab == "email" ? "#fff" : '#000', background: addTab == "email" ? "#337ab7" : '#d8d6d6', padding: '10px', borderRadius: '6px', cursor: 'pointer' }} onClick={() => HandleAddTab("email")}>Configure Email Template</h4>
                                    <h4 style={{ marginTop: '10px', fontSize: '16px', color: addTab == "upload" ? "#fff" : '#000', background: addTab == "upload" ? "#337ab7" : '#d8d6d6', padding: '10px', borderRadius: '6px', cursor: 'pointer' }} onClick={() => HandleAddTab("upload")}>Upload Template</h4>
                                </div>
                                <hr style={{ color: '#c7c8c9', borderTop: '3px solid #c7c8c9', marginTop: '10px' }} />


                                {
                                    addTab == "email" ?
                                        <>
                                            <div className="row" style={{ marginTop: '40px' }}>
                                                <div className="col-sm-4 col-xs-12">
                                                    <label>Subject</label>
                                                    <input type='text' className='form-control' value={objectData?.emailSubject} onChange={(e) => handleAddchange(e, "emailSubject")} />
                                                </div>
                                                <div className="col-sm-4 col-xs-12">
                                                    <label>Template</label>
                                                    <select className='form-control' value={objectData?.fileId} onChange={(e) => handleAddchange(e, "emailPath")}>
                                                        <option>Select option</option>
                                                        {
                                                            uploadListData && uploadListData?.length > 0 ?
                                                                uploadListData?.map((value, index) => {
                                                                    return (
                                                                        <option value={value?.fileId}>{value?.fileName}</option>
                                                                    )
                                                                })
                                                                : ''}

                                                    </select>

                                                </div>
                                                <div className="col-sm-4 col-xs-12">
                                                    <label>Is Async ?</label>
                                                    <div className='custom-switch2' style={{ margin: '10px 0 10px 0px' }}>
                                                        <label class="switch">
                                                            <input type="checkbox" class="checkbox"
                                                                checked={objectData.async}
                                                                onChange={(e) =>
                                                                    setObjectData((prev) => ({
                                                                        ...prev,
                                                                        async: e.target.checked,
                                                                    }))
                                                                }
                                                            />
                                                            <div class="slider"></div>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row" style={{ marginTop: '30px' }}>
                                                <div className="col-xs-12 text-center">
                                                    <button className='btn' style={{ padding: '10px 15px', borderRadius: '6px', background: '#337ab7', color: '#fff' }} onClick={(e) => handleSave(e)}>Save</button>
                                                </div>
                                            </div>
                                        </>
                                        : ''}

                                {
                                    addTab == "upload" ?
                                        <>
                                            <div className="row" style={{ marginTop: '40px' }}>
                                                <div className="col-xs-12">
                                                    <div className="image-upload-wrap" style={{ backgroundSize: '10%', marginTop: '0px' }}>
                                                        <input
                                                            type='file' onChange={(e) => fileHandler(e)} accept='.html,.jsp'

                                                            className="file-upload-input" />
                                                        <div className="drag-text">
                                                            <h5>{filesData?.nameOfFile !== '' ? filesData?.nameOfFile : 'Drag & drop or select HTML or JSP File'}  </h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row" style={{ marginTop: '30px' }}>
                                                <div className="col-xs-12 text-center">
                                                    {
                                                        filesData?.fileToUpload !== null && filesData?.fileToUpload !== undefined && filesData?.fileToUpload !== "" ?
                                                            <button className='btn' style={{ padding: '10px 15px', borderRadius: '6px', background: '#337ab7', color: '#fff', marginRight: '10px' }} onClick={(e) => handlePreview(e)}>Preview</button>
                                                            : ''}
                                                    <button className='btn' style={{ padding: '10px 15px', borderRadius: '6px', background: '#337ab7', color: '#fff' }} onClick={(e) => UploadFile(e)}>Upload</button>
                                                </div>
                                            </div>
                                        </>
                                        : ''}

                            </div>
                        </div>
                        : ""}

                    {
                        TestTemplate?.show ?
                            <div className="background-blur">

                                <div className="popup-main small-popup container-fluid max-width-500px dbl-border " style={{ padding: '20px', borderRadius: '10px' }}>
                                    <i onClick={() => closeTestingPopup(false, "")} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>
                                    <div className="row from-group">
                                        <div className="col-xs-12" style={{ padding: '10px' }}>
                                            <h4 className="text-center" style={{ marginBottom: '10px', marginTop: '10px' }}>Test Whatsapp Template</h4>
                                        </div>
                                    </div>

                                    <div className="row from-group">
                                        {
                                            TemplateObj && Object.keys(TemplateObj)?.length > 0 ?
                                                Object.keys(TemplateObj)?.map((value, i) => {
                                                    return (
                                                        <div className="col-xs-4 col-xs-12" style={{ marginTop: '15px' }}>
                                                            <label htmlFor="">{value}</label>
                                                            <input className='form-control' placeholder={`Enter ${value}`} type="text" value={TemplateObj?.[value]} onChange={(e) => handleTemplateObjChnage(e, value)} />
                                                        </div>
                                                    )
                                                })
                                                : ''}

                                    </div>

                                    <div className="row from-group text-center" style={{ marginTop: '20px' }}>
                                        <div className="col-xs-12">
                                            <button onClick={() => HandleSendTest()} className="btn " style={{ marginTop: '10px', borderRadius: '5px', border: '1px solid #D3D9E9', color: '#fff', boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)', background: '#2B78FF' }}>Send</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            : ""}


                    {
                        previewTemplate?.show ?
                            <>
                                <div className="background-blur">

                                    <div className="popup-main small-popup container-fluid max-width-500px dbl-border " style={{ padding: '20px', borderRadius: '10px', width: '60%' }}>
                                        <i onClick={() => setPreviewTemplate({ show: false, data: "", nameOfFile: "" })} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>
                                        <div className="row from-group">
                                            <div className="col-xs-12" style={{ padding: '10px' }}>
                                                <h4 className="text-center" style={{ marginBottom: '10px', marginTop: '10px' }}>Preview {previewTemplate?.nameOfFile} Template</h4>
                                            </div>
                                        </div>
                                        <div style={{ backgroundColor: '#f4f4f4', padding: '10px', overflow: 'auto', maxHeight: '550px' }}>
                                            <div dangerouslySetInnerHTML={{ __html: previewTemplate?.data }}></div>
                                        </div>


                                    </div>
                                </div>
                            </>
                            : ''}
                </div>





            </div>
        </>
    )
}

export default Email;
